import React from "react";
import { connect } from "react-redux";
import ResetPassword from "../../screens/ResetPassword";

import Actions from "./action";

const ResetPasswordContainer = (props) => {
  return <ResetPassword resetPassword={props.resetPassword} />;
};

const mapStateToProps = (state) => {
  return {
    ...state.ResetReducer,
  };
};

export default connect(mapStateToProps, { ...Actions })(ResetPasswordContainer);
